export default __webpack_public_path__ + "static/beauty-ba8cb05a05285da2ca29eaf7353fdc2f.jpg";